<template>
  <st-side-page class="settings-main-page">
    <portal to="page-name">Configurações</portal>
    <template v-slot:side>
      <ul class="menu">
        <li class="menu-item" v-for="(menu, i) in menus" :key="i">
          <router-link :to="menu.path">{{ menu.label }}</router-link>
          <fa-icon :icon="['fal', 'chevron-right']"/>
        </li>
      </ul>
    </template>
    <router-view/>
  </st-side-page>
</template>

<script>
export default {
  data() {
    return {
      menus: [
        { path: '/settings', label: 'Configurações' },
        { path: '/settings/branches', label: 'Empresas' },
        { path: '/settings/places', label: 'Locais / leitos' },
        { path: '/settings/collaborators', label: 'Colaboradores' },
        { path: '/settings/permission-groups', label: 'Grupos de permissões' },
        { path: '/audits', label: 'Auditoria' },
        { path: '/settings/markers', label: 'Marcadores' },
        { path: '/settings/providers', label: 'Fornecedores' },
        { path: '/messages', label: 'Mensagens' },
        { path: '/settings/tags', label: 'Tags' },
        { path: '/settings/doctoralia', label: 'Doctoralia' },
        { path: '/settings/portal', label: 'Portal Stenci' },
        { path: '/settings/api-keys', label: 'Chaves de API' },
        { path: '/settings/mxmed', label: 'MxMed' },
      ],
    };
  },
};
</script>

<style lang="scss">
@import "./src/assets/scss/_variables.scss";

.settings-main-page {
  &.side-page {
    .side-page-side {
      flex: 0 0 11rem;
    }
  }
  .menu {
    .router-link-exact-active {
      color: $primary-color;
      & + svg {
        color: $primary-color;
      }
    }
  }
}
</style>
